import RegisterBackground from "../components/register/RegisterBackground";

function Register() {
    return (
        <RegisterBackground />
    );
}

export default Register;